import { MutationTree } from 'vuex';
import CmsState from '@/store/modules/cms/types/CmsState';

const mutations: MutationTree<CmsState> = {
  page(state, data) {
    const pages = state.cmsPages.filter((e: any) => e.id === data.id);
    if (!(pages.length > 0)) {
      state.cmsPages.push(data);
    }
  },

  block(state, data) {
    if (!(state.cmsBlocks.filter((e: any) => e.id === data.id).length > 0)) {
      state.cmsBlocks.push(data);
    }
  },
};

export default mutations;
